import moment from 'moment';
import { Endpoint, RequestMethod } from '../../public_api';
import { ApiResponse } from '../apiResponse.interface';
import { MockObservationMaker } from './mockObservationMaker';

export class AddObservation extends Endpoint<void, AddObservationParams> {
  protected callLive(params: AddObservationParams): Promise<void> {
    const bodyFormData = this.createBodyFormDataFromParams(params);
    // console.debug('data', params, bodyFormData);
    const callResponsePromise = this.apiCaller.doCall(
      'observations',
      RequestMethod.POST,
      null,
      bodyFormData,
    );
    /* eslint-disable @typescript-eslint/no-unused-vars */
    return callResponsePromise.then((response: ApiResponse) => null);
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  protected callMock(params: AddObservationParams): Promise<void> {
    const callResponsePromise = ApiResponse.createMockResponseObject(
      MockObservationMaker.doDetailsReplacements(),
    );
    /* eslint-disable @typescript-eslint/no-unused-vars */
    return callResponsePromise.then((response: ApiResponse) => null);
  }

  protected createBodyFormDataFromParams(bodyData: AddObservationParams): FormData {
    // console.debug('createBodyFormDataFromParams', bodyData);
    const formData = new FormData();

    Object.keys(bodyData).forEach((key: string) => {
      if (Array.isArray(bodyData[key])) {
        bodyData[key].forEach((arrayValue) => {
          this.appendFormDataValue(formData, key, arrayValue);
        });
      } else {
        this.appendFormDataValue(formData, key, bodyData[key]);
      }
    });
    return formData;
  }

  protected appendFormDataValue(formData: FormData, key: string, value: File | unknown): void {
    switch (true) {
      case moment.isMoment(value):
        this.appendFormDataValue(formData, key, (value as moment.Moment).toISOString());
        break;
      case value instanceof File:
        formData.append(key, value as Blob, (value as File).name);
        break;
      default:
        formData.append(key, String(value).valueOf());
        break;
    }
  }
}

export interface AddObservationParams {
  epsg_code: string;
  date_observed: moment.Moment;
  x: number;
  y: number;
  observation_type_code: string;
  images: Array<File>;
  keywords: Array<string>;
  description: string;
  i_agree: boolean;
}
